module.exports = __webpack_public_path__ + "static/media/naysis.b1b742ca.png";